import React, { useState } from 'react'
import { Label } from '@/shared/ui/label'
import { Input } from '@/shared/ui/input'
import { Button } from '@/shared/ui/button'
import VerifyPassword from '@/images/SVG/verifyPass.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AuthWrapper } from '@/shared/components/CardWrapper'
import { useTranslation } from 'react-i18next';
import { confirmPasswordReset, requestPasswordReset } from '@/features/auth/lib/resetPassword'

const VerifyPass = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || '';
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleConfirmResetPassword = async () => {
    setLoading(true);
    try {
      await confirmPasswordReset({ email, code, newPassword });
      toast.success(`${t('auth.passwordResetSuccess')}`);
      navigate('/');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    try {
      const output = await requestPasswordReset(email);
      if (output.nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE')
        toast.success(`${t('auth.verificationCodeSent')}`);
    } catch (err) {
      toast.error(err.message);
    }
  }

  return (
    <AuthWrapper icon={VerifyPassword} heading={t('auth.verifyPasswordHeading')}>
      <form className="text-left w-full" onSubmit={(e) => e.preventDefault()}>
        <div className="grid w-full items-center gap-4 text-left mt-5">
          <div className="flex flex-col space-y-1.5">
            <Label htmlFor="verify-code" className="font-semibold">
              {t('auth.verificationCodeLabel')}
            </Label>
            <Input
              required
              id="verify-code"
              placeholder={t('auth.enterVerificationCode')}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="text-[#868C98] font-normal"
            />
          </div>
          <div className="flex flex-col space-y-1.5">
            <Label htmlFor="password" className="font-semibold">
              {t('auth.newPasswordLabel')}
            </Label>
            <Input
              required
              id="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={t('auth.enterPassword')}
              type="password"
              autoComplete="new-password"
              className="text-[#868C98] font-normal"
            />
          </div>
          <Label
            className="font-semibold underline cursor-pointer underline-offset-2"
            onClick={!loading && handleResendCode}
          >
            {t('auth.resendCode')}
          </Label>
          <div className="flex flex-col gap-2 items-center">
            <Button
              className="font-medium w-full"
              variant="default"
              onClick={handleConfirmResetPassword}
              disabled={loading}
            >
              {t('auth.confirmNewPassword')}
            </Button>
            <p className="text-sm font-normal text-[#09090B]">
              {t('auth.changedYourMind')}{' '}
              <span
                onClick={() => navigate(-1)}
                className="text-black font-semibold underline cursor-pointer underline-offset-2"
              >
                {t('auth.goBack')}
              </span>
            </p>
          </div>
        </div>
      </form>
    </AuthWrapper>
  );
};

export default VerifyPass;